import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';

/**
 * 微信登录：微信接口配置
 */
export function getWXInitData(){
  return systemFetch({
    url: 'login/weixin/permit',
    method: 'post'
  });
}

/**
 * 微信登录：获得验证码(这个接口用来做绑定微信登录的时候使用)
 * @param {*} mobile
 */
export function getCode(mobile){
  let params = new URLSearchParams();
  params.append('mobile', mobile);
  return systemFetch({
    url: 'login/weixin/bind/getCode',
    method: 'post',
    data: params
  });
}

/**
 * 微信登录
 */
export function loginForWX(code,state){
  let params = new URLSearchParams();
  params.append('code', code);
  params.append('state', state);
  return systemFetch({
    url: 'login/weixin',
    method: 'post',
    data: params
  });
}

// 学生登录
export function stuLogin(args) {
  const params = new URLSearchParams();
  params.append('account', args.account);
  params.append('password', args.password);

  return systemFetch({
    url: 'login/student',
    method: 'POST',
    data: params
  });
}

export function login(account, password) {
  let params = new URLSearchParams();
  params.append('account', account);
  params.append('password', password);
  return systemFetch({
    url: 'login',
    method: 'post',
    data: params
  });
}
/**
 * 选择学校登录
 * @param {*} account
 * @param {*} password
 * @param {*} schoolId
 */
export function loginForChosedSchoold(account, password,schoolId){
  let params = new URLSearchParams();
  params.append('account', account);
  params.append('password', password);
  params.append('schoolId', schoolId);
  return systemFetch({
    url: 'login',
    method: 'post',
    data: params
  });
}

export function logout(token) {
  let params = new URLSearchParams();
  params.append('token', token);
  return systemFetch({
    url: 'login/logout',
    method: 'post',
    params
  });
}


export function getInfo(token) {
  let params = new URLSearchParams();
  params.append('token', token);
  return systemFetch({
    url: 'login/refresh',
    method: 'post',
    params
  });
}

/**
 * 扫码登录
 * @param {*} schoolId
 * @param {*} wxToken
 */
export function loginWx(schoolId,wxToken){
  let params = new URLSearchParams();
  params.append('schoolId', schoolId);
  params.append('wxToken', wxToken);
  return systemFetch({
    url: 'login/weixin',
    method: 'post',
    data: params
  });
}

// 修改密码
export function modifyPassword(newPwd,oldPwd,userId){
  let params = new URLSearchParams();
  params.append('newPwd', newPwd);
  params.append('oldPwd', oldPwd);
  params.append('userId', userId);
  return systemFetch({
    url: 'login/modifyPassword',
    method: 'post',
    data: params
  });
}

export function fromOldFramework(userToken) {
    let params = new URLSearchParams();
    params.append('userToken', userToken);
    return systemFetch({
        url: 'login/fromOldFramework',
        method: 'GET',
        params
    });
}

export function permissions() {
    let params = new URLSearchParams();

    return systemFetch({
        url: 'oneself/permissions',
        method: 'GET',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/Login/login.js